import React from 'react'
import { Link } from 'gatsby'
import Helmet from 'react-helmet'
import Layout from '../components/layout'
import Banner from '../components/Banner'

import analytics_img from '../assets/images/analytics_img.jpg'
import hiddenseabig from '../assets/images/hiddenseabig.jpg'
import computer from '../assets/images/computer.jpg'
import tombo from '../assets/images/tombo.jpg'
import lego from '../assets/images/lego.jpg'

class HomeIndex extends React.Component {
    render() {

        return (
            <Layout>
                <Helmet
                    title="Gatsby Starter - Forty"
                    meta={[
                        { name: 'description', content: 'Sample' },
                        { name: 'keywords', content: 'sample, something' },
                    ]}
                >
                </Helmet>

                <Banner />

                <div id="main">
                    <section id="one" className="tiles">
                        <article style={{backgroundImage: `url(${analytics_img})`}}>
                            <header className="major">
                                <h3>Language Learning Analytics</h3>
                                <p>Design-Based Research &amp; Development</p>
                            </header>
                            <Link to="/analytics" className="link primary"></Link>
                        </article>
                        <article style={{backgroundImage: `url(${hiddenseabig})`}}>
                            <header className="major">
                                <h3>Through the Introverted Lens</h3>
                                <p>Art-Based Autoethnography Project</p>
                            </header>
                            <Link to="/introvert" className="link primary"></Link>
                        </article>
                        <article style={{backgroundImage: `url(${computer})`}}>
                            <header className="major">
                                <h3>EdApp</h3>
                                <p>Personal Educational App Design Projects</p>
                            </header>
                            <Link to="/edapp" className="link primary"></Link>
                        </article>
                        <article style={{backgroundImage: `url(${tombo})`}}>
                            <header className="major">
                                <h3>Photography</h3>
                                <p>Photo Gallery</p>
                            </header>
                            <Link to="/gallery" className="link primary"></Link>
                        </article>
                        <article style={{backgroundImage: `url(${lego})`}}>
                            <header className="major">
                                <h3>LEGO &amp; Literacy Makerspace</h3>
                                <p>Ideas on STEAM x Literacy</p>
                            </header>
                            <Link to="/lego_literacy" className="link primary"></Link>
                        </article>
                    </section>
                </div>

            </Layout>
        )
    }
}

export default HomeIndex